import { useContext, useState } from 'react';
import { Fab, Zoom, Grid, Button, TextField, MenuItem, ButtonGroup, Chip, Typography, Checkbox, FormControlLabel, Tooltip, IconButton } from '@mui/material';
import { MdSearch as SearchIcon, MdOutlineFilterAlt as FilterIcon, MdClearAll as ClearIcon } from 'react-icons/md';
import { ISearch, ticketsContext } from '../TicketsContext';
import { applicationContext } from 'helpers/services';
import { Autocomplete, FilterContainer, FiltersMenu, MachineAutocomplete } from 'components';
import { getDynamicContrastColor } from 'helpers';
import { localeManagerContext } from 'helpers/Locale';
import { TicketFilters, TicketQueues } from 'helpers/Enums';
import { useIntl } from 'react-intl';
import { LocalizationIds } from 'helpers/Localizations';
import { MobileDatePicker } from '@mui/x-date-pickers';
import moment from 'moment';


let MobileFilters = () => {
    let { formatMessage } = useIntl();

    let appService = useContext(applicationContext);
    let { currentLocale } = useContext(localeManagerContext);

    let { filtersByQueue, defaultSearch, ticketQueues, search, doSearch, searchCustomers, updateSearch, handleTicketCategorySelection, handleSubCategorySelection } = useContext(ticketsContext);

    let [sidebarIsOpen, setSidebarIsOpen] = useState<boolean>(false);

    return (
        <>
            <Grid container spacing={0}>
                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'end', paddingBottom: 0, paddingTop: 0 }}>
                    <Tooltip title={formatMessage({ id: LocalizationIds.ShowFilter })}>
                        <IconButton size="small" onClick={() => { setSidebarIsOpen(false); setSidebarIsOpen(true); }}>
                            <FilterIcon size="24" />
                        </IconButton>
                    </Tooltip>
                </Grid>
            </Grid>
            <FiltersMenu
                caption={formatMessage({ id: LocalizationIds.Filter })}
                menuSide="right"
                sidebarOpen={sidebarIsOpen}
                closeSidebar={() => { setSidebarIsOpen(false); }}
            >
                <FilterContainer onSubmit={() => { doSearch(search); }}>

                    <Grid item xs={12}>
                        <ButtonGroup orientation='vertical' fullWidth>
                            {ticketQueues
                                .map((queue, i) =>
                                    <Button size='small'
                                        key={i}
                                        color={search.ticketQueue === queue.name ? "primary" : "secondary"}
                                        variant={search.ticketQueue === queue.name ? "contained" : "outlined"}
                                        onClick={() => doSearch({
                                            ...defaultSearch,
                                            ticketQueue: queue.name
                                        })}
                                    >
                                        {queue.label}
                                    </Button>
                                )
                            }
                        </ButtonGroup>
                    </Grid>

                    {search.ticketQueue !== TicketQueues.Dashboard &&
                        <>
                            {filtersByQueue.getValueByKey(search.ticketQueue).indexOf(TicketFilters.Ticket) !== -1 &&
                                <Grid item xs={12}>
                                    <TextField
                                        variant="standard"
                                        label={formatMessage({ id: LocalizationIds.Ticket })}
                                        value={search.ticketNumber}
                                        onChange={(e) => {
                                            updateSearch({
                                                ...search,
                                                ticketNumber: e.target.value
                                            });
                                        }}
                                    />
                                </Grid>
                            }
                            {filtersByQueue.getValueByKey(search.ticketQueue).indexOf(TicketFilters.Customer) !== -1 &&
                                <Grid item xs={12}>
                                    <Autocomplete
                                        inputLabel={formatMessage({ id: LocalizationIds.Customer })}
                                        variant="standard"
                                        value={{
                                            value: search.customerId,
                                            label: search.customerName
                                        }}
                                        doSearch={(value: string, etag: number) => searchCustomers(value, etag)}
                                        onChange={(value: any) => {
                                            updateSearch({
                                                ...search,
                                                customerId: value?.value || 0,
                                                customerName: value?.customerName || ''
                                            });
                                        }}
                                    />
                                </Grid>
                            }

                            {filtersByQueue.getValueByKey(search.ticketQueue).indexOf(TicketFilters.Machine) !== -1 &&
                                <Grid item xs={12}>
                                    {(search.orderNumber === '' && search.workOrderNumber === '') &&
                                        <MachineAutocomplete
                                            variant="standard"
                                            inputLabel={formatMessage({ id: LocalizationIds.SearchMachine })}
                                            onChange={(value) => {
                                                let request = { ...search }

                                                if (value.linkedTo === "Order")
                                                    request = {
                                                        ...request,
                                                        orderNumber: value.id.orderNumber,
                                                        orderType: value.id.orderType
                                                    };

                                                if (value.linkedTo === "ProductionOrder")
                                                    request = {
                                                        ...request,
                                                        workOrderNumber: value.id.workOrderNumber
                                                    };

                                                if (search.customerId === 0)
                                                    request = {
                                                        ...request,
                                                        customerId: value.customerId || 0,
                                                        customerName: value.customerName || ''
                                                    }

                                                updateSearch(request);
                                            }}
                                            customerId={(search.customerId === 0 || search.customerId == null) ? undefined : search.customerId}
                                        />
                                    }
                                    {(search.orderNumber !== '' || search.workOrderNumber !== '') &&
                                        <>
                                            Ordini:&nbsp;
                                            {search.orderNumber !== '' &&
                                                <Chip
                                                    color="primary"
                                                    label={`${search.orderType} ${search.orderNumber}`}
                                                    onDelete={() => {
                                                        let request = {
                                                            ...search,
                                                            customerId: 0,
                                                            customerName: '',
                                                            orderNumber: '',
                                                            orderType: ''
                                                        }

                                                        updateSearch(request);
                                                        doSearch(request);
                                                    }}
                                                />
                                            }
                                            {search.workOrderNumber !== '' &&
                                                <Chip
                                                    color="primary"
                                                    label={search.workOrderNumber}
                                                    onDelete={() => {
                                                        let request = {
                                                            ...search,
                                                            customerId: 0,
                                                            customerName: '',
                                                            workOrderNumber: ''
                                                        }

                                                        updateSearch(request);
                                                        doSearch(request);
                                                    }}
                                                />
                                            }
                                        </>
                                    }
                                </Grid>
                            }

                            {filtersByQueue.getValueByKey(search.ticketQueue).indexOf(TicketFilters.Status) !== -1 &&
                                <Grid item xs={12}>
                                    <TextField
                                        select
                                        variant="standard"
                                        SelectProps={{ multiple: true }}
                                        name='status'
                                        label={formatMessage({ id: LocalizationIds.Status })}
                                        value={search.status}
                                        onChange={(e) => {
                                            let request: ISearch = {
                                                ...search,
                                                status: e.target.value as any
                                            }

                                            updateSearch(request);
                                            doSearch(request);
                                        }}
                                    >
                                        {appService.ticketStatuses
                                            .map(u => <MenuItem key={u.code} value={u.code}>{u.descriptions[currentLocale]}</MenuItem>)}
                                    </TextField>
                                </Grid>
                            }

                            {filtersByQueue.getValueByKey(search.ticketQueue).indexOf(TicketFilters.Country) !== -1 &&
                                <Grid item xs={12}>
                                    <TextField
                                        select
                                        variant="standard"
                                        name="countryCode"
                                        label={formatMessage({ id: LocalizationIds.Country })}
                                        value={search.countryCode}
                                        onChange={(e) => {
                                            let request = {
                                                ...search,
                                                countryCode: e.target.value
                                            } as ISearch

                                            updateSearch(request);
                                            doSearch(request);
                                        }}
                                    >
                                        <MenuItem value={''}>{formatMessage({ id: LocalizationIds.Any })}</MenuItem>
                                        {appService.countries.map(c =>
                                            <MenuItem key={c.countryCode} value={c.countryCode}>{c.countryName}</MenuItem>
                                        )}
                                    </TextField>
                                </Grid>
                            }

                            {filtersByQueue.getValueByKey(search.ticketQueue).indexOf(TicketFilters.Assignee) !== -1 &&
                                <Grid item xs={12}>
                                    <TextField
                                        select
                                        variant="standard"
                                        name="filter"
                                        label={formatMessage({ id: LocalizationIds.AssignedTo })}
                                        value={search.assigneeUserName}
                                        onChange={(e) => {
                                            let request = {
                                                ...search,
                                                assigneeUserName: e.target.value
                                            }

                                            updateSearch(request);
                                            doSearch(request);
                                        }}
                                    >
                                        <MenuItem value={''}>{formatMessage({ id: LocalizationIds.Any })}</MenuItem>
                                        <MenuItem value={'null'}>{formatMessage({ id: LocalizationIds.NotAssigned })}</MenuItem>
                                        {appService.simecUsers
                                            .filter(x => x.isDisabled === false)
                                            .filter(x => x.simecClaims.canBeAssignedToTicket === true)
                                            .map(u => <MenuItem key={u.email} value={u.email}>{u.fullName}</MenuItem>)}
                                    </TextField>
                                </Grid>
                            }

                            {filtersByQueue.getValueByKey(search.ticketQueue).indexOf(TicketFilters.Jobsite) !== -1 &&
                                <>
                                    <Grid item xs={12}>
                                        <TextField
                                            select
                                            variant="standard"
                                            name="filter"
                                            label={formatMessage({ id: LocalizationIds.TeamMember })}
                                            value={search.personInTeam}
                                            onChange={(e) => {
                                                let request = {
                                                    ...search,
                                                    personInTeam: e.target.value
                                                }

                                                updateSearch(request);
                                                doSearch(request);
                                            }}
                                        >
                                            <MenuItem value={''}>{formatMessage({ id: LocalizationIds.Any })}</MenuItem>
                                            {appService.simecUsers
                                                .filter(x => x.isDisabled === false)
                                                .filter(x => x.simecClaims.canGoToCustomer === true)
                                                .map(u => <MenuItem key={u.email} value={u.email}>{u.fullName}</MenuItem>)}
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <MobileDatePicker
                                            label={formatMessage({ id: LocalizationIds.JobSiteFrom })}
                                            value={search.dateFrom}
                                            onChange={(value) => {
                                                let newValue = value != null ? moment(value).utc(true).startOf('day') : null;
                                                let request = { ...search, dateFrom: newValue };
                                                updateSearch(request);
                                            }}
                                            renderInput={props => <TextField variant="standard" {...props} />}
                                            inputFormat="DD/MM/YYYY"

                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <MobileDatePicker
                                            label={formatMessage({ id: LocalizationIds.JobSiteTo })}
                                            value={search.dateTo}
                                            onChange={(value) => {
                                                let newValue = value != null ? moment(value).utc(true).startOf('day') : null
                                                let request = { ...search, dateTo: newValue };
                                                updateSearch(request);
                                            }}
                                            renderInput={props => <TextField variant="standard" {...props} />}
                                            inputFormat="DD/MM/YYYY"

                                        />
                                    </Grid>
                                </>
                            }

                            <Grid item xs>
                                <Tooltip TransitionComponent={Zoom} title={formatMessage({ id: LocalizationIds.ClearFilters })}>
                                    <Fab
                                        size="small"
                                        onClick={() => doSearch(defaultSearch)}
                                    >
                                        <ClearIcon size={20} />
                                    </Fab>
                                </Tooltip>
                            </Grid>
                            <Grid item>
                                <Button
                                    type="submit"
                                    size="large"
                                    color="secondary"
                                    variant="outlined"
                                    aria-label="search"
                                >
                                    <SearchIcon />
                                </Button>
                            </Grid>

                            <Grid item xs={12}>
                                <ButtonGroup orientation="vertical" fullWidth>
                                    {appService.ticketCategories
                                        .filter(f => f.subCategories.length > 0)
                                        .map(c =>
                                            <Button
                                                key={c.ticketCategoryId}
                                                fullWidth
                                                color={search.ticketCategoryId === c.ticketCategoryId ? "inherit" : "secondary"}
                                                style={
                                                    search.ticketCategoryId === c.ticketCategoryId
                                                        ? { margin: 0, backgroundColor: c.color, color: getDynamicContrastColor(c.color) }
                                                        : { margin: 0 }
                                                }
                                                variant={search.ticketCategoryId === c.ticketCategoryId ? "contained" : "outlined"}
                                                onClick={() => handleTicketCategorySelection(c.ticketCategoryId)}
                                            >
                                                {c.name[currentLocale]}
                                            </Button>
                                        )}
                                </ButtonGroup>
                            </Grid>

                            {search.ticketCategoryId !== '' &&
                                <Grid item xs={12}>
                                    <Typography variant="body1">
                                        {formatMessage({ id: LocalizationIds.SubCategories })}
                                    </Typography>
                                    <Grid container spacing={0}>
                                        {appService.ticketSubCategories
                                            .filter(f => f.categoryTicketCategoryId === search.ticketCategoryId)
                                            .map(subCategory =>
                                                <Grid item xs={12} key={subCategory.id}>
                                                    <FormControlLabel
                                                        label={subCategory.names[currentLocale]}
                                                        checked={search.ticketSubCategories.findIndex(f => f === subCategory.id) >= 0}
                                                        onChange={() => handleSubCategorySelection(subCategory.id)}
                                                        control={<Checkbox color="secondary" style={{ paddingBottom: 0, paddingTop: 0 }} />}
                                                    />
                                                </Grid>
                                            )}
                                    </Grid>
                                </Grid>
                            }
                        </>
                    }
                </FilterContainer>
            </FiltersMenu>
        </>
    );
}

export default MobileFilters;